<template>
  <v-col :cols="block.cols" :xs="block.colsxs" :sm="block.colssm" :md="block.colsmd" :lg="block.colslg" :xl="block.colsxl" :offset="block.offset">
    <v-row>
      <v-col>
        <v-select
          :value="form.type"
          label="Typ"
          outlined
          dense
          :items="typitems"
          hide-details="auto"
          :class="block.inputClass"
          placeholder=" "
          @input="emitUpdatedForm($event, 'type')"
        />
      </v-col>
      <template v-if="form.type == 'direct'">
        <v-col>
          <v-text-field
            :value="form.ipAddress"
            label="IP-Adresse"
            outlined
            dense
            hide-details="auto"
            placeholder=" "
            @input="emitUpdatedForm($event, 'ipAddress')"
          />
        </v-col>
        <v-col>
          <v-text-field
            :value="form.subnetmask"
            label="Subnetzmaske"
            outlined
            dense
            hide-details="auto"
            placeholder=" "
            @input="emitUpdatedForm($event, 'subnetmask')"
          />
        </v-col>
        <v-col>
          <v-text-field
            :value="form.defaultGateway"
            label="Default Gateway"
            outlined
            dense
            hide-details="auto"
            placeholder=" "
            @input="emitUpdatedForm($event, 'defaultGateway')"
          />
        </v-col>
        <v-col>
          <v-text-field
            :value="form.DNS_extern"
            label="externer DNS"
            outlined
            dense
            hide-details="auto"
            placeholder=" "
            @input="emitUpdatedForm($event, 'DNS_extern')"
          />
        </v-col>
      </template>
      <template v-else>
        <v-col>
          <v-select
            :value="form.anbieter"
            label="Anbieter"
            outlined
            dense
            :items="anbieteritems"
            hide-details="auto"
            placeholder=" "
            @input="emitUpdatedForm($event, 'anbieter')"
          />
          <template v-if="form.anbieter == 'different'">
            <v-text-field
              :value="form.anbieterName"
              label="Anbietername"
              outlined
              dense
              hide-details="auto"
              placeholder=" "
              @input="emitUpdatedForm($event, 'anbieterName')"
            />
          </template>
        </v-col>
        <template v-if="form.anbieter == 'telekom'">
          <v-col>
            <v-select
              :value="form.tarif"
              label="Tarif"
              outlined
              dense
              :items="tarifitems"
              hide-details="auto"
              placeholder=" "
              @input="emitUpdatedForm($event, 'tarif')"
            />
          </v-col>
          <v-col>
            <v-text-field
              :value="form.username"
              label="Zugangsnummer"
              outlined
              dense
              hide-details="auto"
              placeholder=" "
              @input="emitUpdatedForm($event, 'username')"
            />
          </v-col>
          <v-col>
            <v-text-field
              :value="form.password"
              label="persönliches Kennwort"
              outlined
              dense
              hide-details="auto"
              placeholder=" "
              @input="emitUpdatedForm($event, 'password')"
            />
          </v-col>
          <v-col>
            <v-text-field
              :value="form.kennung"
              label="Anschlusskennung"
              outlined
              dense
              hide-details="auto"
              placeholder=" "
              @input="emitUpdatedForm($event, 'kennung')"
            />
          </v-col>
        </template>
        <template v-else>
          <v-col>
            <v-text-field
              :value="form.tarif"
              label="Tarif"
              outlined
              dense
              :items="tarifitems"
              hide-details="auto"
              placeholder=" "
              @input="emitUpdatedForm($event, 'tarif')"
            />
          </v-col>
          <v-col>
            <v-text-field
              :value="form.username"
              label="Benutzername"
              outlined
              dense
              hide-details="auto"
              placeholder=" "
              @input="emitUpdatedForm($event, 'username')"
            />
          </v-col>
          <v-col>
            <v-text-field
              :value="form.password"
              label="Kennwort"
              outlined
              dense
              hide-details="auto"
              placeholder=" "
              @input="emitUpdatedForm($event, 'password')"
            />
          </v-col>
        </template>
      </template>
    </v-row>
  </v-col>
</template>

<script>
export default {
   name: 'VDSL',
   model: {
      prop: 'form',
      event: 'update:form',
   },

   props: {
      block: {
         type: Object,
         required: true,
      },
      form: {
         type: Object,
         required: true,
      },
   },

   data () {
      return {
         typitems: [
            { text: 'VDSL', value: 'vdsl' },
            { text: 'ADSL', value: 'adsl' },
            { text: 'vorgeschalteter Router', value: 'direct' }
         ],
         anbieteritems: [
            { text: 'Telekom', value: 'telekom' },
            { text: '1 & 1', value: '1&1' },
            { text: 'CCNST', value: 'ccnst' },
            { text: 'Osnatel', value: 'osnatel' },
            { text: 'NetCologne', value: 'netcologne' },
            { text: 'anderer Anbieter', value: 'different' }
         ],
         tarifitems: [
            { text: 'DeutschlandLAN / CompanyFlex', value: 'flex' },
            { text: 'Entertain / MagentaTV', value: 'magenta' }
         ]
      }
   },

   watch: {
      form: {
         deep: true,
         handler (val, oldVal) {
            console.log(val)
            this.$emit('update:form', this.form)
         },
      },
   },

   methods: {
      emitUpdatedForm (newVal, key) {
         const oldVal = this.form[key]
         if (key === 'anbieter' && oldVal === 'telekom') {
            this.form.tarif = null
         }
         this.form[key] = newVal
      }
   }
}
</script>

<style>

</style>
